"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _times = _interopRequireDefault(require("lodash/times"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

/* eslint-disable @typescript-eslint/prefer-ts-expect-error */
const Wrapper = _styledComponents.default.div`
  display: ${props => props.visible ? 'block' : 'contents'};
`;

class ProgressiveList extends React.Component {
  // eslint-disable-line react/sort-comp
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "requestId", void 0);
    (0, _defineProperty2.default)(this, "ref", void 0);
    (0, _defineProperty2.default)(this, "isLoading", false);
    (0, _defineProperty2.default)(this, "handleScroll", e => {
      const {
        rowCount,
        progressiveAmount,
        useWindowScroll
      } = this.props;
      const {
        numRenderRows
      } = this.state;
      let top;
      let height;
      let scrollHeight;
      let reachedLimit;

      if (useWindowScroll && this.ref.current !== null) {
        const boundingClientRect = this.ref.current.getBoundingClientRect();
        top = boundingClientRect.top;
        height = boundingClientRect.height;
        scrollHeight = window.innerHeight;
        reachedLimit = top + height < scrollHeight;
      } else if (e.target instanceof HTMLElement) {
        top = e.target.scrollTop;
        height = e.target.offsetHeight;
        scrollHeight = e.target.scrollHeight;
        reachedLimit = top + height >= scrollHeight;
      }

      if (reachedLimit && numRenderRows !== rowCount && !this.isLoading) {
        this.loadMore(progressiveAmount);
      }
    });
    (0, _defineProperty2.default)(this, "progressivelyLoadMore", (immediateLoad = true) => {
      const {
        rowCount,
        idleAmount
      } = this.props;
      const {
        numRenderRows
      } = this.state;
      if (!window.requestIdleCallback || idleAmount === 0) return;
      if (immediateLoad) this.loadMore(idleAmount);

      if (numRenderRows < rowCount) {
        // @ts-ignore Started when upgrading to TS 4.8
        this.requestId = window.requestIdleCallback(this.progressivelyLoadMore);
      }
    });
    const {
      rowCount: _rowCount,
      initialAmount,
      isActive
    } = props;
    this.ref = /*#__PURE__*/React.createRef();
    this.state = {
      numRenderRows: isActive ? initialAmount : _rowCount
    };
  }

  componentDidMount() {
    if (this.props.scrollParent != null) {
      this.ref = this.props.scrollParent;
    }

    this.progressivelyLoadMore(false);
    const {
      useWindowScroll
    } = this.props;
    const scrollParent = useWindowScroll ? window : this.ref.current.parentElement;
    scrollParent.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rowCount !== this.props.rowCount || prevProps.initialAmount !== this.props.initialAmount) {
      this.initializeList(this.props);
    }
  }

  componentWillUnmount() {
    // @ts-ignore Started when upgrading to TS 4.8
    window.cancelIdleCallback(this.requestId);
    const scrollParent = this.props.useWindowScroll ? window : this.ref.current.parentElement;
    scrollParent.removeEventListener('scroll', this.handleScroll);
  }

  initializeList(props) {
    const {
      rowCount,
      isActive,
      initialAmount
    } = props; // @ts-ignore Started when upgrading to TS 4.8

    window.cancelIdleCallback(this.requestId);
    this.setState({
      numRenderRows: isActive ? initialAmount : rowCount
    }, () => {
      this.progressivelyLoadMore(false);
    });
  }

  loadMore(amount) {
    const {
      rowCount
    } = this.props;
    if (this.state.numRenderRows >= rowCount) return;
    this.isLoading = true;
    this.setState(state => ({
      numRenderRows: Math.min(state.numRenderRows + amount, rowCount)
    }), () => {
      this.isLoading = false;
    });
  }

  render() {
    const {
      className,
      renderItem,
      scrollParent
    } = this.props;
    const {
      numRenderRows
    } = this.state;
    return /*#__PURE__*/React.createElement(Wrapper, {
      visible: scrollParent === undefined,
      ref: scrollParent === undefined ? this.ref : null,
      className: className
    }, (0, _times.default)(numRenderRows, i => renderItem(i)));
  }

}

(0, _defineProperty2.default)(ProgressiveList, "defaultProps", {
  className: undefined,
  idleAmount: 0,
  // load one extra row on idle by default
  initialAmount: 10,
  isActive: true,
  progressiveAmount: 10,
  renderLoader: () => null,
  useWindowScroll: false
});
var _default = ProgressiveList;
exports.default = _default;
module.exports = exports.default;